module.exports = __webpack_public_path__ + "img/damage-total.2218458e.png";